export const RolesList = [
  { label: "Super Admin", key: "SUPER_ADMIN" },
  { label: "Admin", key: "ADMIN" }
];


export const SuccessMessage = "success";
export const ErrorMessage = "error";
export const PdfMessage = "Pdf Generated Successfully";


export const IdlePopUp = {
  Discription: "Your session expired please login.",
  Accept: "Ok",
  Alert: "Alert",
};
export const status = "status";
export const SelectStore = "Select Store";
export const name = "name";
export const LastName = "Last Name";
export const lastName = "lastName";

export const email = "email";

export const AddUser = "Add User";
export const EditUser = "Edit User";

export const EnterFirstName = "Enter First Name";
export const EnterLastName = "Enter Last Name";
export const Emails = "Email";
export const SelectRole = "Select Role";

export const UserProfile = "User Profile";

//Settings constants

export const CommonConstants={
  FIRST_NAME:"First Name *",
  LAST_NAME:"Last Name *",
  USER_EMAIL:"Email *",
  PHONE_NUMBER:"Phone Number",
  SPARE_PART_ID: "Spare Part ID :",
  PRODUCT_ID: "Product ID :"
}

export const SettingsConstants={
  MANAGE_PROC_TEAM:"Procurement Team Configuration",
  ADD_MEMBER:"Add Member",
  ADD_TEXT:"Add",
  CANCEL_TEXT:"Cancel",
  EDIT_MEMBER:"Edit Member",
  UPDATE_TEXT:"Update",
  MANAGE_PROC_BREDCUM:"Procurement Team Configuration",
  SETTINGS_TEXT:"Settings",
  YES_TEXT:"YES",
  NO_TEXT:"NO",
  SAVE_MEMBER:"Do you want to save new member?",
  NOT_SAVED:"Member Not Saved",
  REMOVE_MEMBER:"Remove Member?",
  REMOVE_CONFORM:"Are you sure you want to remove member?",
  UPDATE_MEMBER_TEXT:"Member Not Updated",
  UPDATE_CONFORM:"Do you want to save updates?",
  NUMBER_INVALID_TEXT:"Phone number is invalid"
}

export const listQR = "Selecting a Project ID will list all products of the project and will allow to generate QR codes for all products together.";
export const listSingleQR = "Selecting a Project ID will allow to select a product of the project from the list and will allow to generate QR code for the selected product.";

export const Yes = "YES";
export const No = "NO";
export const NotSaved = "User Not Saved";
export const SaveNewUser = "Do you want to save new user?"; 
export const PflNotSaved = "Profile Not Saved";
export const PflSaveNewUser = "Do you want to save Profile?"; 
export const Updated = "User Not Updated";
export const UpdateSave = "Do you want to save updates?";
export const DeleteTitle = "Remove User?";
export const DeleteSubTitle = "Are you sure you want to remove user?";
export const NoData = "No Data Available";

// Slice
export const productSuccess = "Products Loaded Successfully";
export const modelTypeUpdated = "ModelType updated successfully.";
export const modelTypeCreated = "ModelType created successfully.";
export const productModelSuccess = "All products-details are uploaded successfully";
export const productUpdateSuccess = "Product updated successfully";
export const spareSuccess = "Spare Parts Loaded Successfully";
export const Removed = "User Removed";

export const SparePlaceholder = "Enter Spare Part ID";
export const ProductPlaceholder = "Enter Serial Number";
export const UpdateProductPlaceholder="Enter Replaced Project Id"
export const listingPlaceholder = "Enter User Name";
export const AddPlaceholder ="Enter First Name";
export const LastPlaceholder ="Enter Last Name";
export const EmailPlaceholder ="Enter Email";

export const PhoneValidation ="Phone number is invalid";
export const ProfilePhoneValidation ="Please enter a valid phone number in the correct format";

export const GenerateQR = "Generate QR Code";
export const ManageProduct = "Manage Products";
export const ManageSpare = "Manage Spare Parts";
export const ManageUser = "Manage Users";
export const MobileAppUsage="Mobile App Usage";
export const SaveQRCode = "QR Code Not Saved";
export const NotSaveQRCode = "Do you want to save QR code?"

export const OLD = 'old';
export const NEW = 'new';
export const CONFIRM = 'confirm';

export const EMAIL_MANDATORY = 'Email mandatory';
export const PWD_MANDATORY = 'Password mandatory'; // NOSONAR S2068 - UI validation message, not a password

export const REQUIRED_FEILDS = 'Please enter required fields.';
export const EXIST_PASSWORD = 'Please enter valid existing password!.'; // NOSONAR S2068 - UI validation message, not a password
export const CONFIRM_PASSWORD_ERROR = 'Please make sure new password and confirm password are same.'; // NOSONAR S2068 - UI validation message, not a password
export const RECONFIRM_PASSWORD = 'Please make sure old and new passwords should not be same.'; // NOSONAR S2068 - UI validation message, not a password
export const VALID_EMAIL = 'Please Enter Valid Email Id';
export const VALID_PWD = 'Please enter valid Password'; // NOSONAR S2068 - UI validation message, not a password

export const TRY_AGAIN = 'Try after sometime!!!';
export const PWD_NOT_MATCH = 'Password not matching'; // NOSONAR S2068 - UI validation message, not a password
export const RESET_SUCCESS = 'Password Reseted Succussfully login using new Password'; // NOSONAR S2068 - UI validation message, not a password

export const JWT_EXPIRED = "jwt expired";
export const JWT_MALFORMED = "jwt malformed";
export const axiosApi = {
  ERROR: 'There is an error!',
  TOKEN_DENIED: "Token in deny list"
};